import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class InvoiceTransactionConfiguration  {
    _originalTypeClassName = "zERP.BO.InvoiceTransactionConfiguration";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
InvoiceTransactionConfiguration.translate = translateService;
}
this.SupportedIncomeClassifications = [];
this.SupportedExpensesClassifications = [];
this.Id = null;
this.TransactionType = null;
this.Enabled = false;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
TransactionType:any;
Enabled:any;
SupportedIncomeClassifications:any;
SupportedExpensesClassifications:any;
static setSupportedIncomeClassifications = ($this, items) => {
                if (items == null) items = [];
                if ($this.SupportedIncomeClassifications == null) $this.SupportedIncomeClassifications = [];

                const copyItems = Common.cloneObject(items);

                while ($this.SupportedIncomeClassifications.length > 0) {
                    Domain.InvoiceTransactionConfiguration.removeSupportedIncomeClassifications($this, $this.SupportedIncomeClassifications[0]);
                }

                Domain.InvoiceTransactionConfiguration.addManySupportedIncomeClassifications($this, copyItems);
            }
static addManySupportedIncomeClassifications = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.InvoiceTransactionConfiguration.addSupportedIncomeClassifications($this, items[i]);
                }
            }
static addSupportedIncomeClassifications = ($this, item) => {
                if ($this.SupportedIncomeClassifications == null) $this.SupportedIncomeClassifications = [];
                if (item == null || $this.SupportedIncomeClassifications.indexOf(item) > -1) return;
                $this.SupportedIncomeClassifications.push(item);
}
static addRangeSupportedIncomeClassifications = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.InvoiceTransactionConfiguration.addSupportedIncomeClassifications($this, item));
            }
static removeSupportedIncomeClassifications = ($this, item) => {
                if ($this == null || $this.SupportedIncomeClassifications == null || $this.SupportedIncomeClassifications.indexOf(item) === -1) return;
                var _index = $this.SupportedIncomeClassifications.indexOf(item);
                $this.SupportedIncomeClassifications.splice(_index, 1);
}
static clearSupportedIncomeClassifications = ($this) => { $this.SupportedIncomeClassifications = null; }
static setSupportedExpensesClassifications = ($this, items) => {
                if (items == null) items = [];
                if ($this.SupportedExpensesClassifications == null) $this.SupportedExpensesClassifications = [];

                const copyItems = Common.cloneObject(items);

                while ($this.SupportedExpensesClassifications.length > 0) {
                    Domain.InvoiceTransactionConfiguration.removeSupportedExpensesClassifications($this, $this.SupportedExpensesClassifications[0]);
                }

                Domain.InvoiceTransactionConfiguration.addManySupportedExpensesClassifications($this, copyItems);
            }
static addManySupportedExpensesClassifications = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.InvoiceTransactionConfiguration.addSupportedExpensesClassifications($this, items[i]);
                }
            }
static addSupportedExpensesClassifications = ($this, item) => {
                if ($this.SupportedExpensesClassifications == null) $this.SupportedExpensesClassifications = [];
                if (item == null || $this.SupportedExpensesClassifications.indexOf(item) > -1) return;
                $this.SupportedExpensesClassifications.push(item);
}
static addRangeSupportedExpensesClassifications = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.InvoiceTransactionConfiguration.addSupportedExpensesClassifications($this, item));
            }
static removeSupportedExpensesClassifications = ($this, item) => {
                if ($this == null || $this.SupportedExpensesClassifications == null || $this.SupportedExpensesClassifications.indexOf(item) === -1) return;
                var _index = $this.SupportedExpensesClassifications.indexOf(item);
                $this.SupportedExpensesClassifications.splice(_index, 1);
}
static clearSupportedExpensesClassifications = ($this) => { $this.SupportedExpensesClassifications = null; }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}